var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");

require("appdev/wizards/user_search.scss");

class UserSearch extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { searchData: {}, loading: false }
	}

	updateSearchData(attribute, event) {
		if (event.target.value != "") {
			var updatedData = _.clone(this.state.searchData);
			updatedData[attribute] = event.target.value;
		} else {
			var updatedData = _.omit(this.state.searchData, attribute);
		}
		this.setState({ searchData: updatedData });
	}

	submitSearch() {
		this.setState({ loading: true });
		CurrentUser.api().getUsers({ ...this.state.searchData, embed: 'student.primary_student_list,user.school,user.primary_school_org' }, $wr.apiHandler((response) => {
			this.setState({ loading: false }, () => {
				this.props.updateResults(response.users);
			});
		}));
	}
	// submit on enter
	handleKeyDown(e) {
		if (e.keyCode === 13) {
			this.submitSearch();
		}
	}

	render() {
		return (
			<div className="userSearch" onKeyDown={this.handleKeyDown}>
				<div className='userInputRowOne'>
					<input type="text" placeholder="User ID" className="form-control"
						onChange={this.updateSearchData.bind(this, "id")} />
					<input type="text" placeholder="Email" className="form-control"
						onChange={this.updateSearchData.bind(this, "email")} />
					<input type="text" placeholder="Email (Exact Match)" className="form-control"
						onChange={this.updateSearchData.bind(this, "email_exact")} />
					<input type="text" placeholder="Username" className="form-control"
						onChange={this.updateSearchData.bind(this, "username")} />
				</div>
				<div className='userInputRowTwo'>
					<input type="text" placeholder="First Name" className="form-control"
						onChange={this.updateSearchData.bind(this, "first_name")} />
					<input type="text" placeholder="Last Name" className="form-control"
						onChange={this.updateSearchData.bind(this, "last_name")} />
					<input type="text" placeholder="Google ID" className="form-control"
						onChange={this.updateSearchData.bind(this, "google_id")} />
					<input type="text" placeholder="Clever ID" className="form-control"
						onChange={this.updateSearchData.bind(this, "clever_id")} />
					<LoadingButton className="btn buttonPrimary" onClick={this.submitSearch}
						loading={this.state.loading} text="Search" />
				</div>
			</div>
		);
	}

};

UserSearch.propTypes = PageStrictPropTypes({
	updateResults: PropTypes.func.isRequired,
});

module.exports = UserSearch;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/UserSearch.js